import { useFormContext } from 'react-hook-form'
import { AttendeeFormData } from 'domain/models/AttendeeFormData/AttendeeFormData'
import { ValidAttendeeFormData } from 'domain/models/AttendeeFormData/ValidAttendeeFormData'

export const useAttendeeFormContext = useFormContext<
  AttendeeFormData,
  any,
  ValidAttendeeFormData
>
